<template>
  <div>
    <EmailEditar :exame="formData" :showForm="showFormEdit" :parent="this" />
    <EmailTeste :exame="formData" :showForm="showFormTeste" :parent="this" />

    <TableView
      registerName="Inserir Email"
      :onRegister="onRegister"
      :onEdit="onEdit"
      :onDelete="onDelete"
      :onSearch="getContaEmail"
      :tableHead="tableHead"
      :tableData="tableData"
      :loadingTable="loadingTable"
      :pagination="pagination"
      :response="response"
    ></TableView>
  </div>
</template>

<script>
import TableView from "common/table";
import Rest from "common/rest";
import EmailEditar from "./editar";
import EmailTeste from "./teste";

export default {
  name: "exame",
  components: { TableView, EmailEditar, EmailTeste },
  mixins: [Rest],
  data() {
    return {
      formData: {
        id: 0,
        nome: null,
        usuario: null,
        email: null,
        servidor_smtp: null,
        autenticacao: 1,
        conexao_seg: "tls",
        senha: null,
        tempo_espera: 0,
        porta: 0,
        n_msg_pct: 50,
        t_esp_pct: 600,
        updated_at: null
      },
      pagination: {},
      response: {},
      tableHead: [
        {
          key: "nome",
          sortable: true,
          label: "Nome"
        },
        {
          key: "email",
          sortable: true,
          label: "Email"
        },
        {
          key: "usuario",
          sortable: true,
          label: "Usuário"
        },
        {
          key: "tipo",
          sortable: true,
          label: "Serviços Vinculados"
        }
      ],
      tableData: [],
      loadingTable: false,
      loadingTest: false,
      showFormEdit: false,
      showFormTeste: false
    };
  },
  beforeDestroy() {
    this.tableData = [];
  },
  created() {},

  mounted: function() {
    this.getContaEmail();
  },

  methods: {
    onRegister: function() {
      this.showFormEdit = !this.showFormEdit;
      this.formData = {
        id: 0,
        nome: null,
        usuario: null,
        email: null,
        servidor_smtp: null,
        autenticacao: 1,
        conexao_seg: "tls",
        senha: null,
        porta: 0,
        tempo_espera: 0,
        n_msg_pct: 50,
        t_esp_pct: 600,
        updated_at: null,
        tipo: []
      };
    },

    onEdit: function(data) {
      this.showFormEdit = !this.showFormEdit;

      this.formData = {
        id: data.id,
        nome: data.nome,
        usuario: data.usuario,
        email: data.email,
        servidor_smtp: data.servidor_smtp,
        autenticacao: data.autenticacao,
        conexao_seg: data.conexao_seg,
        porta: data.porta,
        senha: null,
        tempo_espera: data.tempo_espera,
        n_msg_pct: data.n_msg_pct,
        t_esp_pct: data.t_esp_pct,
        updated_at: data.updated_at,
        tipo: data.tipo
      };
    },

    onDelete: function(data) {
      var self = this;

      this.$confirm(
        "O sistema vai excluir " +
          data.length +
          " registro(s). Deseja prosseguir?",
        "Atenção",
        {
          confirmButtonText: "OK",
          cancelButtonText: "Cancelar",
          type: "warning"
        }
      ).then(() => {
        self.loadingTable = true;

        this.post("/conta-email/deletar", { ids: data }).then(result => {
          result = result[0];

          self.loadingTable = false;

          if (result.status == 200) {
            self.getContaEmail();
            self.edMsg("Registo excluido com sucesso");
          }
        });
      });
    },

    onTest(data) {
      this.showFormTeste = !this.showFormTeste;
      this.formData = {
        id: data.id,
        email: data.email
      };
    },

    getContaEmail: function(_search, _page, _pagination) {
      this.loadingTable = true;
      this.response = {};

      this.get("conta-email", {
        search: _search,
        page: _page,
        pagination: _pagination
      }).then(result => {
        result = result[0];
        this.response = result;

        if (result.status == 200) {
          var data = result.data.data,
            tableData = [],
            pagination = result.data;

          for (var i = 0; i < data.length; i++) {
            var tipo = [];

            for (let j = 0; j < data[i].tipo.length; j++) {
              const element = data[i].tipo[j];
              tipo.push(element.descricao);
            }

            var item = {
              id: data[i].id,
              nome: data[i].nome,
              email: data[i].email,
              usuario: data[i].usuario,
              servidor_smtp: data[i].servidor_smtp,
              tipo: tipo.length > 0 ? tipo.join("<br>") : "---",
              _data: data[i],
              options: {
                disable_delete: !this.validarPermissao(3),
                disable_edit: !this.validarPermissao(3)
              },
              buttons: [
                {
                  icon: "fa fa-check",
                  color: "success",
                  title: "Enviar Email Teste",
                  click: this.onTest
                }
              ]
            };

            tableData.push(item);
          }

          this.pagination = pagination;
          this.tableData = tableData;
          this.loadingTable = false;
        }
      });
    }
  }
};
</script>


// WEBPACK FOOTER //
// index.vue?055359d0